import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { CustomerInfoComponent } from '../customer.info.component';
import { Customer } from '../../../shared/models/customer.interface';

@Component({
  selector: 'app-customer-info-mobile',
  templateUrl: './customer-info-mobile.component.html',
  styleUrls: ['./customer-info-mobile.component.scss']
})
export class CustomerInfoMobileComponent extends CustomerInfoComponent implements OnInit {

  @Input()
  public set customerObject(value: Customer) {
    if (value) {
      // clone object to keep changes local
      let customer = (<any>Object).assign({}, value) as Customer;
      this.loadCustomer(customer);
    }
  }

  @Output() updated = new EventEmitter<Customer>();

  ngOnInit(): void {
    super.ngOnInit();
  }
}
